module.exports = __webpack_public_path__ + "static/img/tupian_ewm02.d48a906.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/tupian_ewm02.png
// module id = QyIO
// module chunks = 10